import { ModalContainer } from "@kanda-libs/ks-component-ts";
import { FunctionComponent } from "react";
import PropensioXidModalForm from "components/payment/PaymentInfoBanner/PaymentOverrideButtons/PropensioXidModal/PropensioXidModalForm";
import { PROPENSIO_XID_MODAL_ID } from "components/payment/PaymentInfoBanner/PaymentOverrideButtons/constants";
import { PropensioCallbackProps } from "../usePaymentOverrideButtons";

export interface PropensioXidModalProps extends PropensioCallbackProps {}

const PropensioXidModal: FunctionComponent<PropensioXidModalProps> = function ({
  propensioCallback,
  setPropensioCallback,
}) {
  return (
    <ModalContainer id={PROPENSIO_XID_MODAL_ID} opacity={30}>
      {({ handleClose, ref }) => (
        <PropensioXidModalForm
          handleClose={handleClose}
          ref={ref}
          propensioCallback={propensioCallback}
          setPropensioCallback={setPropensioCallback}
        />
      )}
    </ModalContainer>
  );
};

export default PropensioXidModal;
